export const sources={};export const img={src:"__VITE_ASSET__BC5dNsns__",w:36,h:36};export default{sources:sources,img:img};